<div class="dialog">
    <div class="dialog-header">
        <h3 *ngIf="data.document.salesDocumentTypeId !== 5">{{ 'SALES_DOCUMENT|Dodałeś przedmiot do oferty' | translate}}</h3>
        <h3 *ngIf="data.document.salesDocumentTypeId === 5">{{ 'SALES_DOCUMENT|Dodałeś przedmiot do zamówienia' | translate}}</h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <div class="flex-horizontal w-100">
            <img [src]="data.product?.mainPhoto?.variants?.listMdX1?.webp">
            <section class="fg-2" >
                <h3>{{ data.product.name }}</h3>
                <p class="product-code">{{ data.product.code }}</p>
                <p class="product-prices">
                    <span *ngIf="data.document.salesDocumentTypeId !== 5">{{ data.price.value * data.quantity | multiplier: data.product.id : true | exchange: data.price.currency | taxRate: data.price | currency }}</span>
                    <span>{{ data.quantity }} {{ data.unit | unit:data.quantity }} {{data.unit.factorDesc}}<ng-container *ngIf="data.document.salesDocumentTypeId !== 5"> x {{ data.price.value  | multiplier: data.product.id : true | exchange: data.price.currency | taxRate: data.price | currency }} </ng-container></span>
                </p>
            </section>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="flex-horizontal w-100">
            <button iccButton appearance="flat" (click)="close()">{{ data.document.salesDocumentTypeId === 5 ? ('SALES_DOCUMENT|Zamawiaj dalej' | translate) : ('SALES_DOCUMENT|Kupuj dalej' | translate)}}</button>
            <div class="flex-horizontal right">
                <button iccButton (click)="goToOffer()" *ngIf="data.document.salesDocumentTypeId !== 5">{{ 'SALES_DOCUMENT|Przejdź do oferty' | translate}}</button>
                <button iccButton (click)="goToOffer()" *ngIf="data.document.salesDocumentTypeId === 5">{{ 'SALES_DOCUMENT|Przejdź do zamówienia' | translate}}</button>
            </div>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>
